import type { ChartData, ChartOptions } from 'chart.js'
import type { ChartType, PriceData } from '../types'

export interface ChartConfig {
  labels: string[]
  datasets: {
    fill: boolean
    label: string
    data: number[]
    borderColor: string
    backgroundColor: string
    tension: number
    pointRadius: number
    borderWidth: number
  }[]
}

export function createChartConfig(
  ticker: string,
  data: PriceData[],
  type: ChartType
): ChartData {
  if (type === 'candlestick') {
    return {
      // labels: data.map(d => new Date(d.r)),
      labels: data.map(d => new Date(d.d)),
      datasets: [{
        label: 'Price', //ticker, 
        data: data?.map(d => ({
          // x: new Date(d.r).getTime(),
          x: new Date(d.d).getTime(),
          o: d.adj_open,
          h: d.adj_high,
          l: d.adj_low,
          c: d.adj_close
        }))
      }]
    }
  }

  return {
    // labels: data.map(d => d.r),
    labels: data.map(d => d.d),
    datasets: [
      {
        label: 'Price', //ticker,
        // data: data.map(d => d.adj_close),
        data: data.map(d => d.p),
        yAxisID: 'y',
        borderColor: 'rgb(75, 141, 192)',
        backgroundColor: 'rgba(100, 135, 184, 0.1)',
        fill: true,
        tension: 0.1,
        borderWidth: 1.5,
        pointRadius: 0,
        pointHoverRadius: 4,
        pointHoverBackgroundColor: 'rgb(75, 141, 192)',
        pointHoverBorderColor: 'rgb(75, 141, 192)'
      // },
      // {
      //   label: 'Volume',
      //   data: data.map(d => d.v),
      //   yAxisID: 'volume',
      //   type: 'bar',
      //   backgroundColor: 'rgba(100, 135, 184, 0.3)',
      //   borderColor: 'rgba(100, 135, 184, 0.3)',
      //   borderWidth: 0,
      //   barPercentage: 1,
      //   categoryPercentage: 1,
      //   order: 1
      }
    ]
  }
}

// Move chart options to client component
export const baseChartOptions: Omit<ChartOptions<'line'>, 'scales'> = {
  responsive: true,
  maintainAspectRatio: false,
  animation: {
    duration: 400,
    easing: 'easeOutQuart'
  },
  transitions: {
    active: {
      animation: {
        duration: 0
      }
    }
  },
  plugins: {
    legend: { display: false, position: 'bottom' },
    tooltip: {
      mode: 'index',
      intersect: false,
      backgroundColor: 'rgb(255, 255, 255)',
      titleColor: 'rgb(0, 0, 0)',
      bodyColor: 'rgb(0, 0, 0)',
      borderColor: 'rgba(0, 0, 0, 0.1)',
      borderWidth: 1,
      padding: 10,
      displayColors: false
    },
  },
  interaction: {
    mode: 'nearest',
    axis: 'x',
    intersect: false
  },
}